import React, { useState } from 'react';
import { Battery, Calculator } from 'lucide-react';
import Header from '../Home/header';
import Footer from '../Home/footer';
import '../../css/header-menu/calculator.css';

const ChargingCalculator = () => {
    const [activeTab, setActiveTab] = useState('charging');
    // Şarj hesaplayıcı state'leri
    const [batteryCapacity, setBatteryCapacity] = useState('');
    const [maxChargingPower, setMaxChargingPower] = useState('');
    const [chargingTime, setChargingTime] = useState(null);

    // Tasarruf hesaplayıcı state'leri
    const [electricityRate, setElectricityRate] = useState('');
    const [fuelPrice, setFuelPrice] = useState('');
    const [fuelConsumption, setFuelConsumption] = useState('');
    const [savings, setSavings] = useState(null);
    const [evConsumption, setEvConsumption] = useState('');

    // Şarj süresini hesapla
    const calculateChargingTime = () => {
        if (!batteryCapacity || !maxChargingPower) return;

        const battery = parseFloat(batteryCapacity);
        const power = parseFloat(maxChargingPower);
        const chargingRange = 0.6; // %20'den %80'e
        const hours = (battery * chargingRange) / power;

        setChargingTime({
            hours: Math.floor(hours),
            minutes: Math.round((hours % 1) * 60)
        });
    };

    // Tasarruf hesapla
    const calculateSavings = () => {
        if (!electricityRate || !fuelPrice || !fuelConsumption || !evConsumption) return;

        // Değerleri al
        const electricityPerKwh = parseFloat(electricityRate);
        const fuelPricePerLiter = parseFloat(fuelPrice);
        const fuelConsumptionPer100 = parseFloat(fuelConsumption);
        const evConsumptionPer100 = parseFloat(evConsumption);

        // 100 km'deki maliyet hesaplamaları
        const electricityCostPer100km = evConsumptionPer100 * electricityPerKwh;
        const fuelCostPer100km = fuelConsumptionPer100 * fuelPricePerLiter;

        // Tasarruf hesaplamaları
        const savingsPer100km = fuelCostPer100km - electricityCostPer100km;
        const yearlySavings = (savingsPer100km * 20000) / 100;

        setSavings({
            per100km: Math.round(savingsPer100km * 100) / 100,
            yearly: Math.round(yearlySavings)
        });
    };

    return (
        <div>
            <Header />
            <div className="calculator-container">
                <h1 className="calculator-title">Hesaplayıcılar</h1>

                <div className="tabs">
                    <div className="tabs-list">
                        <button
                            className={`tab-trigger ${activeTab === 'charging' ? 'active' : ''}`}
                            onClick={() => setActiveTab('charging')}
                        >
                            <Battery />
                            Şarj Süresi Hesaplayıcı
                        </button>
                        <button
                            className={`tab-trigger ${activeTab === 'savings' ? 'active' : ''}`}
                            onClick={() => setActiveTab('savings')}
                        >
                            <Calculator />
                            Tasarruf Hesaplayıcı
                        </button>
                    </div>

                    {activeTab === 'charging' && (
                        <div className="card">
                            <div className="input-group">
                                <label className="input-label">Aracınızın Batarya Kapasitesi (kWh)</label>
                                <input
                                    type="number"
                                    className="input-field"
                                    value={batteryCapacity}
                                    onChange={(e) => setBatteryCapacity(e.target.value)}
                                    placeholder="Örn: 58"
                                />
                            </div>

                            <div className="input-group">
                                <label className="input-label"> AC/DC Şarj Gücü (kW)</label>
                                <input
                                    type="number"
                                    className="input-field"
                                    value={maxChargingPower}
                                    onChange={(e) => setMaxChargingPower(e.target.value)}
                                    placeholder="Örn: 11"
                                />
                            </div>

                            <button className="calc-button" onClick={calculateChargingTime}>
                                Hesapla
                            </button>

                            {chargingTime && (
                                <div className="result-box charging-result">
                                    <h3 className="result-title">Tahmini Şarj Süresi (Bataryanızın %20 ile %80 kapasitesi aralığında)</h3>
                                    <p className="result-value">
                                        {chargingTime.hours} saat {chargingTime.minutes} dakika
                                    </p>
                                    <h3 className='CalculateHeader'>UYARI</h3>
                                    <p>Elektrikli araçlarda şarj süreçleri, batarya yönetim sistemleri tarafından yönetilir. Bu nedenle şarj süresi, (sıcaklık, mevcut kapasite vb.) faktörlere bağlı olarak değişkenlik gösterebilir. Burada yapılan hesaplama teoriktir ve gerçek uygulamalara daha yakın sonuçlar elde edebilmek için batarya kapasitesinin %20 ile %80 aralığı dikkate alınır. Çünkü araçlar genellikle bu kapasite aralığında daha stabil bir şarj performansı sergiler</p>
                                </div>
                            )}
                        </div>
                    )}

                    {activeTab === 'savings' && (
                        <div className="card">
                            <div className="input-group">
                                <label className="input-label">Elektrikli Araç Tüketimi (kWh/100km)</label>
                                <input
                                    type="number"
                                    className="input-field"
                                    value={evConsumption}
                                    onChange={(e) => setEvConsumption(e.target.value)}
                                    placeholder="Ortalama: 15"
                                />
                            </div>

                            <div className="input-group">
                                <label className="input-label">Elektrik Tarife Ücreti (TL/kWh)</label>
                                <input
                                    type="number"
                                    className="input-field"
                                    value={electricityRate}
                                    onChange={(e) => setElectricityRate(e.target.value)}
                                    placeholder="Ortalama: 5"
                                />
                            </div>

                            <div className="input-group">
                                <label className="input-label">Yakıt Fiyatı (TL/lt)</label>
                                <input
                                    type="number"
                                    className="input-field"
                                    value={fuelPrice}
                                    onChange={(e) => setFuelPrice(e.target.value)}
                                    placeholder="Ortalama: 48"
                                />
                            </div>

                            <div className="input-group">
                                <label className="input-label">Aracın Yakıt Tüketimi (lt/100km)</label>
                                <input
                                    type="number"
                                    className="input-field"
                                    value={fuelConsumption}
                                    onChange={(e) => setFuelConsumption(e.target.value)}
                                    placeholder="Ortalama: 7"
                                />
                            </div>

                            <button className="calc-button" onClick={calculateSavings}>
                                Hesapla
                            </button>

                            {savings && (
                                <div className="result-box savings-result">
                                    <h3 className="result-title">Yaklaşık Kazanç:</h3>
                                    <p className="result-value">100 km'de: {savings.per100km} TL</p>
                                    <p className="result-value">Yıllık (20.000 km): {savings.yearly} TL</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ChargingCalculator;